import React from 'react';
import ProfileCard from './card';
import PropertiesListSection from './properties';
import useFetch from '../../hooks/useFetch';
import { getUserById } from '../../services/userService';
import { getUserData } from '../../Utils/localStorageUtils';

const ProfilePage = () => {
  const userData = getUserData(); // Retrieve user data from local storage
  const userId = userData?._id; // Extract _id
  const populateProperties = true; // Include properties in the response

  // Using the useFetch hook
  const { data: user, loading, error } = useFetch(
    () => getUserById(userId, populateProperties),
    [userId, populateProperties]
  );

  if (loading) {
    return (
      <div className="flex items-center justify-center py-[200px] w-full">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500 border-solid"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="py-[200px] w-full flex items-center justify-center text-red-500">
        Error: {error.message}
      </div>
    );
  }

  return (
    <div className="py-[200px] w-full">
      <ProfileCard user={user?.data || {}} />
      <PropertiesListSection properties={user?.data?.properties || []} />
    </div>
  );
};

export default ProfilePage;
